App.RecursiveCategoriesListComponent = Em.Component.extend
  categories: null
  disabled: false
  currentLevel: null
  
  levelObserver: (->
    @set('currentLevel', if @get('level') then @get('level') + 1 else 1)
  ).on('init')



  cssClass: (->
    "level-#{@get('currentLevel')}"
  ).property('currentLevel')

  actions:
    reorderCategory: (category, target, layout, rerender) ->
      @sendAction('onItemReorder', category, target, layout, rerender)